export const getEquipmentType = (equipmentType?: string, pointType?: string) => {
  if (!equipmentType) {
    return '';
  }

  if (equipmentType === 'mote') return 'sensor';
  if (equipmentType === 'router') return 'repeater';
  if (equipmentType === 'sensor' && pointType === 'tach') return 'tachometer';

  return equipmentType;
};
